<template>
  <div class="go-back-container td-200">
    <button class="go-back" :class="`go-back-color-${theme}`" @click="onClickGoBack">
      <no-drag-image :src="imageUrl" />
      {{ $t('misc.goBack') }}
    </button>
  </div>
</template>

<script>
import NoDragImage from '@/components/common/NoDragImage';

import ButtonBackBlue from '@/assets/btn-back.png';
import ButtonBackWhite from '@/assets/btn-back-white.png';

export default {
  name: 'GoBackButton',
  components: {
    NoDragImage,
  },
  props: {
    theme: {
      type: String,
      default: 'blue',
      required: false,
    },
  },
  emits: ['goBack'],
  computed: {
    imageUrl() {
      if (this.theme === 'white') {
        return ButtonBackWhite;
      }
      return ButtonBackBlue;
    },
  },
  methods: {
    onClickGoBack() {
      this.$emit('goBack');
    },
  },
};
</script>

<style lang="scss" scoped>
//$height: 25px;

.go-back {
  height: 25px;
  width: auto;
  outline: 0;
  border: 0;
  margin-top: 27px;
  background: transparent;

  &.go-back-color-white {
    color: white;
  }

  &.go-back-color-blue {
    color: inherit;
  }

  &:focus {
    outline: 0;
    border: 0;
    box-shadow: none;
  }

  img {
    max-height: 100%;
  }
}
</style>
